import React from "react";
import "./portfolio.css";
import PORT_IMG1 from "../../assets/img/portfolio/1.webp";
import PORT_IMG2 from "../../assets/img/portfolio/2.webp";
import PORT_IMG3 from "../../assets/img/portfolio/3.webp";
import PORT_IMG4 from "../../assets/img/portfolio/4.webp";
import PORT_IMG5 from "../../assets/img/portfolio/5.webp";
import PORT_IMG6 from "../../assets/img/portfolio/6.webp";
import PORT_IMG7 from "../../assets/img/portfolio/7.webp";
import PORT_IMG8 from "../../assets/img/portfolio/8.webp";
import PORT_IMG9 from "../../assets/img/portfolio/9.webp";

const projects = [
  {
    id: 100,
    img: PORT_IMG1,
    title: "Design Plus",
    git: "",
    demo: "http://designplusksa.com/",
  },
  {
    id: 150,
    img: PORT_IMG2,
    title: "Etisalat Fitness",
    git: "",
    demo: "http://fitness.etisalatsports.com/",
  },
  {
    id: 200,
    img: PORT_IMG3,
    title: "Etisalat Sports ( Local Football )",
    git: "",
    demo: "http://etisalatsports.com/local/ar",
  },
  {
    id: 250,
    img: PORT_IMG4,
    title: "Etisalat Sports ( International Football )",
    git: "",
    demo: "http://etisalatsports.com/international/ar",
  },
  {
    id: 300,
    img: PORT_IMG5,
    title: "Etisalat Sports ( Squash )",
    git: "",
    demo: "http://etisalatsports.com/squash",
  },
  {
    id: 350,
    img: PORT_IMG6,
    title: "Stadvodafone",
    git: "",
    demo: "http://stadvodafone.com/",
  },
  {
    id: 400,
    img: PORT_IMG7,
    title: "ZednyBooks",
    git: "",
    demo: "http://zednybooks.com/",
  },
  {
    id: 450,
    img: PORT_IMG8,
    title: "Etisalat Sports ( Africa Football )",
    git: "",
    demo: "http://etisalatsports.com/africa",
  },
  {
    id: 500,
    img: PORT_IMG9,
    title: "Orange Sports",
    git: "",
    demo: "",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {projects.map((project) => (
          <a
            href={project.demo}
            target="_blank"
            key={project.id}
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay={project.title}
            rel="noreferrer"
          >
            <article className="portfolio__item">
              <div className="portfolio__item-image">
                <img loading="lazy" src={project.img} alt={project.title} />
              </div>
              {/* <h3>{project.title}</h3>
            <div className="portfolio__item-cta">
              <a href={project.demo} className="" target="_blank">
                <AiOutlineLink />
                Link
              </a>
            </div> */}
            </article>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
